export const requiredValidation = (v: string) => !!v || 'Field is Required'
